import { AnimateOnScrollChild, AnimateOnScroll } from './_transitions/animate_on_scroll';
import { BannerImage } from "./bannerImage";
import parse from 'html-react-parser';

const Banner = ({ banner, category }: { banner: any; category: string }) => {
    const path = window.location.pathname;
    let isITeach = path.includes("iTeach");
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';

    return (
        <section className="banner-section">
            {banner?.data?.banner && banner.data.banner.map((item: any, index: number) => (
                item.Category === category && (
                    <AnimateOnScroll transition=' ' className='banner normal container' key={index}>
                        <div className="banner-image">{item.image && (
                            <AnimateOnScrollChild as={`span`} transition={`fade`} >
                                <BannerImage src={`${locateSrc}${item.image.url}`} alt={item.title} aspectRatio={`515/395`} />
                            </AnimateOnScrollChild>
                        )}</div>
                        <div className="banner-content">
                            {isITeach == true && (
                                <AnimateOnScrollChild transition={`fade`} delay={200} >
                                    <img
                                        src={`${locateSrc}${banner.data.Logo.url}`}
                                        alt={banner.data.Logo.alternativeText} />
                                </AnimateOnScrollChild>
                            )}
                            <AnimateOnScrollChild as={`h1`} transition={`fade`}>
                                {item.title ? parse(item.title) : null}
                            </AnimateOnScrollChild>
                            <AnimateOnScrollChild as={`p`} transition={`fade`} delay={300}>
                                {item.description ? parse(item.description) : null}
                            </AnimateOnScrollChild>
                        </div>
                    </AnimateOnScroll>
                )))}
        </section>
    );
};

export default Banner;
